import React from 'react';
import RequestApp from './Functionality/RequestApp';
import RequestMealTable from './SubComponents/RequestMealTable';
import { SUB_VIEW_MODEL } from '../Model/Models';
import RequestSummaryModal from './Modal/RequestSummaryModal';
import HistoryTable from "./SubComponents/HistoryTable";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const Request = ({
    setBodyForExport,

    subView,
    setSubView,
    modified,
    setModified,

    searchElement,
    setSearchElement,
    option,
    setOption,
    setSearch,
    simpleSearch,
    setSimpleSearch,
    setModuleId,
    setCriteria,
    finalArray,
    setFinalArray
}) => {
    const {
        handleBtnRequest,
        handleBtnHistory,
        itemSelected,
        setItemSelected,
        summaryModalShow,
        setSummaryModalShow
    } = RequestApp({
        setSubView,
        setOption,
        setModuleId,
        setFinalArray,
        setSearchElement
    });

    return (
        <>
            { subView === SUB_VIEW_MODEL.REQUEST.REQUEST && (
                <RequestMealTable
                    optionView={subView}
                    handleBtnRequest={handleBtnRequest}
                    handleBtnHistory={handleBtnHistory}
                    itemSelected={itemSelected}
                    setItemSelected={setItemSelected}
                    setSummaryModalShow={setSummaryModalShow}
                    modified={modified}
                    setModified={setModified}
                    setBodyForExport={setBodyForExport}
                    setCriteria={setCriteria}


                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    option={option}
                    setSearch={setSearch}
                    simpleSearch={simpleSearch}
                    setSimpleSearch={setSimpleSearch}
                />
            )}
            { subView === SUB_VIEW_MODEL.REQUEST.HISTORY && (
                <HistoryTable
                    optionView={subView}
                    handleBtnRequest={handleBtnRequest}
                    handleBtnHistory={handleBtnHistory}
                    setItemSelected={setItemSelected}
                    setSummaryModalShow={setSummaryModalShow}
                    modified={modified}
                    setModified={setModified}
                    setBodyForExport={setBodyForExport}

                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    option={option}
                    setSearch={setSearch}
                    simpleSearch={simpleSearch}
                    setSimpleSearch={setSimpleSearch}

                    setCriteria={setCriteria}
                    finalArray={finalArray}
                />
            )}
               <RequestSummaryModal
                item={itemSelected}
                open={summaryModalShow}
                onHide={() => setSummaryModalShow(false)}
            />
        </>
    );
};

export default Request;
